const configuredApiUrl =
  process.env.VUE_APP_API_URL || 'http://localhost:7271'

export const API_BASE_URL = configuredApiUrl.replace(/\/+$/, '')

export const buildApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  return `${API_BASE_URL}${normalizedPath}`
}